import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

export type Breadcrumb = {
  name: string
  link?: string | null
  iconName?: string | null
  iconUrl?: string | null
  iconType?: string | null
  isIcon?: boolean
  label?: string | null
}

export const useNavbarStore = defineStore('navbarStore', () => {
  const breadcrumbs = ref<Breadcrumb[]>([])

  const setBreadcrumb = (payload: Breadcrumb[]): void => {
    breadcrumbs.value = payload
  }

  return {
    breadcrumbs: readonly(breadcrumbs),
    setBreadcrumb
  }
})
